module.exports = __webpack_public_path__ + "img/logo.f174859e.png";